import { v4 as uuid } from 'uuid';
import { SessionRequest, SessionRequestType } from './types';

export const marshalRequest = (
  quoteNumber: string,
  quoteReference: string,
  requestType: SessionRequestType
): SessionRequest => ({
  MsgMessageId: uuid(),
  UpdateSessionRequest: {
    RequestHeader: {
      PegaID: quoteReference,
      RequestType: requestType,
      TransRefGUID: uuid(),
      ReferenceID: quoteNumber,
      RequestedBy: 'NEWEQ3',
    },
  },
});
